<template>
  <div v-if="isOpen" class="dialog-overlay">
    <div class="dialog-box">
      <h3>{{ title }}</h3>
      <p v-if="user">
        Are you sure you want to delete <strong>{{ user.name }}</strong>? You can't undo this action.
      </p>
      <p v-else>{{ message }}</p>
      <div class="dialog-buttons">
        <button class="btn cancel" @click="closeDialog">{{ cancelText }}</button>
        <button class="btn delete" @click="confirmDelete">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Delete Notification?"
    },
    message: {
      type: String,
      default: "Are you sure you want to delete this item?"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    confirmText: {
      type: String,
      default: "Delete"
    }
  },
  data() {
    return {
      isOpen: false,
      user: null
    };
  },
  methods: {
    openDialog(user) {
      this.user = user;
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
      this.user = null;
      this.$emit("cancel");
    },
    confirmDelete() {
      this.isOpen = false;
      this.$emit("confirm", this.user);
      this.user = null;
    }
  }
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.dialog-box {
  background: white;
  padding: 20px;
  border-radius: 4px;
  width: 600px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.dialog-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: end;
  gap: 10px;
}

.btn {
  padding: 10px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.btn.cancel {
  background: #ccc;
}

.btn.delete {
  background: #FFAD01;
  color: white;
}
</style>
